import { render, staticRenderFns } from "./ZeroBalanceInsight.vue?vue&type=template&id=ff3d84d8&scoped=true"
import script from "./ZeroBalanceInsight.vue?vue&type=script&lang=js"
export * from "./ZeroBalanceInsight.vue?vue&type=script&lang=js"
import style0 from "./ZeroBalanceInsight.vue?vue&type=style&index=0&id=ff3d84d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3d84d8",
  null
  
)

export default component.exports